// API
import api from '../../api'

// Utilities
import isEmpty from '../../utility/isEmpty'
import Logger from '../../utility/loggerUtil'

export default {
  async getStoreInfo (context, payload) {
    try {
      const response = await api.store.getStoreDetails(undefined, payload.mobileMoneyLocation, payload.mobileMoneyType, payload.storeNumber)

      response.mobileMoneyLocation = payload.mobileMoneyLocation
      response.mobileMoneyType = payload.mobileMoneyType

      context.commit('setStoreForMobile', response)

      response.storeInfo.number = response.storeInfo.id // for the benefit of the return value; the `setStoreForMobile` mutator already sets the `number` state property
      return response
    } catch (error) {
      Logger.error('Error on applicationRetailStore/getStoreInfo')
      Logger.debug(error)
      throw error
    }
  },

  async searchStoresByZip (context, data) {
    try {
      const response = await api.applicationRetailStore.searchStoresByZip(data.zipcode, data.limit, data.state)
      return response
    } catch (error) {
      Logger.error('Error on applicationRetailStore/searchStoresByZip')
      Logger.debug(error)
      throw error
    }
  },

  async searchStoresByAddress (context, storeAddress) {
    try {
      const response = await api.applicationRetailStore.searchStoresByAddress(storeAddress.address, storeAddress.city, storeAddress.state, storeAddress.zip)
      return response
    } catch (error) {
      Logger.error('Error on applicationRetailStore/searchStoresByAddress')
      Logger.debug(error)
      throw error
    }
  },

  async setClosestStore (context, data) {
    let storeList
    if (data.address && data.city && data.state) {
      storeList = await context.dispatch('searchStoresByAddress', { address: data.address, city: data.city, state: data.state, zip: data.zip }).catch(error => {
        Logger.error('Error on applicationRetailStore/searchStoresByAddress')
        Logger.debug(error)
        throw error
      })
    } else {
      storeList = await context.dispatch('searchStoresByZip', { zipcode: data.zip, state: data.state, limit: data.limit }).catch(error => {
        Logger.error('Error on applicationRetailStore/searchStoresByZip')
        Logger.debug(error)
        throw error
      })
    }

    if (isEmpty(storeList)) {
      return
    }

    let retailStore = storeList[0]

    if (!isEmpty(data.state)) {
      retailStore = storeList.find((store) => {
        return data.state === store.state
      })
    }

    context.commit('setStore', retailStore)
    return retailStore
  },

  async updateStore (context, data) {
    try {
      const response = await api.applicationRetailStore.updateStore(data.storeNumber, context.rootState.applicationCustomer.applicationId)
      context.commit('applicationCustomer/updateCustomerInfo', {
        selectedRetailStore: data.storeNumber
      }, { root: true })

      context.commit('setStore', { number: data.storeNumber })
      return response
    } catch (error) {
      Logger.error('Error on applicationRetailStore/updateStore')
      Logger.debug(error)
      throw error
    }
  },

  async updateLocalStore (context, data) {
    try {
      context.commit('applicationCustomer/updateCustomerInfo', {
        selectedRetailStore: data.storeNumber
      }, { root: true })
      context.commit('setStore', { number: data.storeNumber })
    } catch (error) {
      Logger.error('Error on applicationRetailStore/updateStore')
      Logger.debug(error)
      throw error
    }
  }
}
